import type { IconData } from '@stacksjs/iconify-core'

export const basicUiBin: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 4v2h-2v10H2V6H0V4h4a4 4 0 1 1 8 0zM8 2a2 2 0 0 1 2 2H6a2 2 0 0 1 2-2\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiBin
